import { TextField, Stack, Box, Grid, IconButton, Tooltip, Popover, MenuItem } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';

import { AddCircle, Edit } from '@mui/icons-material';
import { ActionButtons } from '../../others/ActionButtons';
import { StringEditor } from './components/editors/StringEditor';

export const ModalEditor = ({
  KeysPath,
  isEditorAdd,
  isEditorEdit,
  value,
  onChange
}) => {

  const [valJson, setValJson] = useState('');
  const [keyJson, setKeyJson] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? `simple-popover-` : undefined;

  const resetForm = useCallback(() => {
    setKeyJson('');
    setValJson('');
  }, []);

  const handleClickOpenModal = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickCloseModal = () => {
    setAnchorEl(null);
  };

  const handleClickSaveModal = () => {
    onChange(keyJson, valJson);
    setAnchorEl(null);
    resetForm();
  }

  useEffect(() => {
    if ('keyItem' in value && 'valueItem' in value && isEditorEdit) {
      setKeyJson(value.keyItem);
      setValJson(value.valueItem);
    }
  }, [value.keyItem, value.valueItem])

  return (
    <Box>
      <Tooltip title={isEditorAdd ? 'Add' : isEditorEdit && 'Edit'}>
        <IconButton
          id={id}
          aria-describedby={id}
          size="small"
          sx={{ p: 0 }}
          onClick={handleClickOpenModal}
        >
          {
            isEditorAdd ?
              <AddCircle sx={{ fontSize: 17 }} />
              : isEditorEdit && <Edit sx={{ fontSize: 17 }} />
          }
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
      >
        <Box
          sx={{ py: 3, px: 2 }}
          width={500}
        >
          <Stack
            width="100%"
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            <spam>{KeysPath} /</spam>
            <Stack
              display="flex"
              flex="1"
              width="100%"
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              sx={{ pt: 1 }}
            >
              <Grid container>
                <Grid size={{ md:4 }} sx={{ px: 1 }}>
                  <TextField
                    size="small"
                    fullWidth
                    label="Property Name"
                    value={keyJson}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setKeyJson(e.target.value)}
                  />
                </Grid>
                <Grid size={{ md:4 }}>
                  <TextField
                    select
                    label="Type"
                    size="small"
                    fullWidth
                    value={'string'}
                    // onChange={(e) => updateValue(e.target.value)}
                    disabled
                  >
                    <MenuItem key={'string'} value={'string'}>
                      string
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid size={{ md:4 }} sx={{ px: 1 }}>
                  <StringEditor
                    label="Value"
                    // value={getChild(obj, path)}
                    value={valJson}
                    onChange={setValJson}
                  // onChange={updateObj}
                  />
                </Grid>
              </Grid>

              <Box width="100%">
                <Stack direction="row" spacing={1}>
                  <Box sx={{ flexGrow: 1 }} />
                  <ActionButtons
                    onSubmit={handleClickSaveModal}
                    onCancel={handleClickCloseModal}
                  />
                </Stack>
              </Box>
            </Stack>
          </Stack>
        </Box>
      </Popover>
    </Box>
  );
}
